import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";

const AddLeaveType = ({ show, onClose, onSuccess }) => { 
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [leaveName, setLeaveName] = useState('');
  const [description, setDescription] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Capitalize first letter of each word
  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const handleCreate = async () => {
    if (!leaveName.trim()) {
      setError('Leave Type is required');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${baseURL}/manage-leavetype`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          leavetype_name: leaveName,   // <-- Updated field name to match backend
          description,
        }),
      });

      if (!response.ok) {
        const errData = await response.json();
        setError(errData.message || 'Failed to create leave type');
        setLoading(false);
        return;
      }

      // Success
      setLoading(false);
      setLeaveName('');
      setDescription('');
      onClose();

      if (onSuccess) onSuccess(); // Notify parent to refresh list or whatever
    } catch (e) {
      setError('Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Leave Type</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Leave Type<span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Leave Type"
                value={leaveName}
                onChange={(e) => setLeaveName(capitalizeWords(e.target.value))}
                disabled={loading}
              />
              {error && <div className="text-danger mb-2">{error}</div>}
            </div>
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={3}
                className="h-auto form-control"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>
              Cancel
            </Link>
            <Button variant="primary" size="sm" onClick={handleCreate} disabled={loading}>
              {loading ? 'Creating...' : 'Create Leave Type'}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddLeaveType;
